import AbstractParticipationStatusModel from './AbstractParticipationStatusModel';
import doc                              from '@widesk-core/decorators/doc';
import model                            from '@widesk-core/decorators/model';

@doc.urnResource('participation_status')
@model.cacheDuration()
export default class ParticipationStatusModel extends AbstractParticipationStatusModel {
	get color() {
		switch (this.reference) {
			case 'ENABLED':
				return 'green';
			case 'DISABLED':
				return 'red';
		}
	}
}
